import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'
import { lighten } from 'polished'

import { Text } from '../../Atoms/Typography'
import Icon from '../../Atoms/Icon'
import Touchable from '../../Atoms/Touchable'
import TranslatedText from '../../Atoms/TranslatedText'

import { translate } from '../../../services/translate'
import theme from '../../../styles/theme'

const Card = styled(View)`
  flex: 1;
`

const CardContent = styled(View)`
  border-top-left-radius: ${theme.gutterUnit}px;
  border-top-right-radius: ${theme.gutterUnit}px;
  flex: 6;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${2 * theme.gutterUnit}px;
`

const CardMetrics = styled(View)`
  margin-top: -1px;
  border-bottom-left-radius: ${theme.gutterUnit}px;
  border-bottom-right-radius: ${theme.gutterUnit}px;
  flex: 4;
  flex-direction: column;
  padding: ${2 * theme.gutterUnit}px;
  align-items: center;
  justify-content: space-around;
`

const PlaceLabel = styled(View)`
  width: 80px;
  height: 40px
  border-radius: 20px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const ValueRow = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const Column50 = styled(View)`
  width: 50%;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`

const Column25 = styled(View)`
  width: 25%;
  align-items: center;
`

const HelpIcon = styled(View)`
  align-self: flex-end;
  height: 30px;
  z-index: 10;
  margin: -10px;
`

const IconContainer = styled(View)`
  margin-top: -30px;
`

const colourMap = [
  theme.colours.orange,
  theme.colours.blue,
  theme.colours.magenta,
  theme.colours.third,
  theme.colours.purple,
  theme.colours.darkBlue
]

const iconNameMap = {
  TSR: 'loan',
  NPS: 'nps',
  ROE: 'roe',
  Customers: 'customers',
  LIE: 'credit',
  Rating: 'rating',
  EmployeeEngagement: 'customers',
  Community: 'leaf',
  RiskIncidents: 'danger',
  Complaints: 'dislike',
  RegulatorActions: 'gavel'
}

class SummaryItem extends PureComponent {
  render () {
    const { item, onPressHelpHandler, index } = this.props
    // const { metrics = {}, placeChanges = {} } = content
    const hasItemPlace = !!item.place.value
    const type = item.type
    const colour = colourMap[index % colourMap.length]
    const iconName = iconNameMap[item.type]
    const { value, suffix: valueSuffix } = item.value
    const { value: place, ordinal } = item.place
    let { value_change: valueChange } = item
    let { value: placeChange, suffix: placeChangeSuffix } = item.place_change
    let valueChangeStyles = {}
    if (valueChange === 'No Change') {
      valueChangeStyles = { textAlign: 'center' }
      valueChange = translate('summaryScreen.placeChanges.noChange', valueChange)
    }
    if (placeChange === 'No Change') {
      placeChange = translate('summaryScreen.placeChanges.noChange', placeChange)
    } else if (placeChange !== undefined) {
      const placeChangeNum = placeChange.slice(1, placeChange.length)
      placeChangeSuffix = (parseInt(placeChangeNum) > 1 || parseInt(placeChangeNum) < -1) ? translate('summaryScreen.placeChanges.places', placeChangeSuffix) : translate('summaryScreen.placeChanges.place', placeChangeSuffix)
    }
    return (
      <Card>
        <CardContent style={{ backgroundColor: lighten(0.1, colour) }}>
          <HelpIcon>
            <Touchable onPress={(evt) => onPressHelpHandler(evt, item.helpHeading, item.helpBody)}>
              <Icon name='help' size='xxl' />
            </Touchable>
          </HelpIcon>
          <IconContainer>
            <Icon name={iconName} />
          </IconContainer>
          <TranslatedText size='xl' medium white center value={`summaryScreen.metrics.${type}.heading`} default={item.heading} />
        </CardContent>
        <CardMetrics style={{ backgroundColor: colour }}>
          <ValueRow style={{ marginBottom: 30 }}>
            <Column25 />
            <Column50 style={{ alignItems: 'flex-end' }}>
              <Text size='huger' medium white>{value}</Text>
              <TranslatedText size='xl' medium white overrides={{ marginBottom: 6 }} value={`summaryScreen.metrics.${type}.unit`} default={valueSuffix} />
            </Column50>
            <Column25>
              {hasItemPlace && <Text size='m' overrides={valueChangeStyles}>{valueChange}</Text>}
            </Column25>
          </ValueRow>
          {hasItemPlace ? (
            <ValueRow style={{ marginBottom: 15 }}>
              <Column25 />
              <Column50>
                <PlaceLabel style={{ backgroundColor: lighten(0.1, colour) }}>
                  <Text size='xxl' medium white overrides={{ marginBottom: 4 }}>{place}</Text>
                  <Text medium white overrides={{ marginBottom: -4 }}>{ordinal}</Text>
                </PlaceLabel>
              </Column50>
              <Column25>
                <Text size='m' overrides={{ textAlign: 'center' }}>{placeChange}</Text>
                {placeChangeSuffix && <Text size='m'>{placeChangeSuffix}</Text>}
              </Column25>
            </ValueRow>
          ) : (
            <ValueRow>
              <Column25 />
              <Column50>
                <Text size='m' overrides={{ ...valueChangeStyles, marginBottom: 20 }}>{valueChange}</Text>
              </Column50>
              <Column25 />
            </ValueRow>
          )}
        </CardMetrics>
      </Card>
    )
  }
}

export default SummaryItem
